import { selectRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const Select = styled('select', selectRecipe);
export type SelectProps = HTMLStyledProps<typeof Select>;
